<div class="add-custom-map-wrapper">
  <div class="custom-maps-fields">
    <h1>{{ "company.baseMaps.addMap" | translate }}</h1>

    <form [formGroup]="customMapForm">
      <ng-template #slugTemplate>
        <div class="form-row" *ngIf="isSuperAdmin">
          <mat-form-field>
            <input
              [maxLength]="identifierMaxLength"
              formControlName="Slug"
              type="text"
              required
              [placeholder]="'components.dtmTab.customElevations.slug' | translate"
              matInput
            />
            <mat-error *ngIf="customMapForm.get('Slug').errors && customMapForm.get('Slug').errors.pattern">
              {{ "validation.is_not_valid" | translate: { name: ("components.dtmTab.customElevations.slug" | translate) } }}
            </mat-error>
            <mat-error *ngIf="customMapForm.get('Slug').errors && customMapForm.get('Slug').errors.required">
              {{ "validation.required" | translate: { name: ("components.dtmTab.customElevations.slug" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>
      </ng-template>

      <mee-permissions-fields-sa-ca
        *ngIf="isSuperAdmin || isCompanyAdmin; else permissionsForTeamAdmin"
        [selectedItem]="null"
        [isUpdateMode]="false"
        (changePermissionsData)="onChangePermissionsData($event)"
        [slugFieldTemplateRef]="slugTemplate"
        [nameFieldTemplateRef]="nameTemplate"
      ></mee-permissions-fields-sa-ca>

      <ng-template #permissionsForTeamAdmin>
        <mee-permissions-fields-ta
          [selectedItem]="null"
          [isUpdateMode]="false"
          (changePermissionsData)="onChangePermissionsData($event)"
          [slugFieldTemplateRef]="slugTemplate"
          [nameFieldTemplateRef]="nameTemplate"
        ></mee-permissions-fields-ta>
      </ng-template>

      <ng-template #nameTemplate>
        <div class="form-row name-wrapper">
          <mat-form-field>
            <input matInput placeholder="{{ 'company.baseMaps.name' | translate }}" [required]="true" formControlName="Name" />
            <span matSuffix>{{ customMapForm.get("Slug").value }}</span>
            <mat-error *ngIf="customMapForm.get('Name').errors && customMapForm.get('Name').errors.required">
              {{ "validation.required" | translate: { name: ("company.baseMaps.name" | translate) } }}
            </mat-error>
            <mat-error *ngIf="customMapForm.get('Name').errors && customMapForm.get('Name').errors.notUnique">
              {{ "company.baseMaps.customMapUniqueName" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </ng-template>

      <div class="form-row">
        <mat-form-field>
          <mat-select name="MapType" formControlName="Type" [required]="true" placeholder="{{ 'company.baseMaps.mapType' | translate }}">
            <mat-option *ngFor="let map of maps" [value]="map.value">
              {{ map.name }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              customMapForm.get('Type').errors &&
              customMapForm.get('Type').errors.required &&
              (customMapForm.get('Type').dirty || customMapForm.get('Type').touched)
            "
            >{{ "validation.required" | translate: { name: ("company.baseMaps.mapType" | translate) } }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="arcgis-custom-map-form" *ngIf="isArcGisMapService()">
        <mee-arcgis-custom-map-form
          [mapServerUrlsOfCustomMapProviders]="mapServerUrlsOfCustomMapProviders"
          (arcGisDataChanged)="arcGisDataChanged($event)"
        ></mee-arcgis-custom-map-form>
      </div>

      <!--Begin WMTS map service-->

      <div class="wmts-custom-map-form" *ngIf="isWMTSMapService()">
        <mee-wmts-custom-map-form
          (selectedLayerChanged)="onWmtsSelectedLayerChanged($event)"
          (onWMTSDataChanged)="onWMTSDataChanged($event)"
        ></mee-wmts-custom-map-form>
      </div>

      <!--End WMTS map service-->

      <!--Begin WMS map service-->

      <div class="wms-custom-map-form" *ngIf="isWMSMapService()">
        <mee-wms-custom-map-form
          (selectedLayerChanged)="onWmsSelectedLayerChanged($event)"
          (onWMSDataChanged)="onWMSDataChanged($event)"
        ></mee-wms-custom-map-form>
      </div>

      <!--End WMS map service-->
    </form>

    <div class="action-buttons">
      <button class="cancel-button" [mat-dialog-close]="null" mat-button>{{ "system.cancel" | translate | uppercase }}</button>
      <div class="add-custom-map-button">
        <button
          mat-raised-button
          class="add-custom-map--button"
          [disabled]="!isProviderFormValid()"
          [class.disabled]="!isProviderFormValid()"
          (click)="onAddMap()"
        >
          <span>{{ "company.baseMaps.add" | translate | uppercase }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="map-preview">
    <mee-map-preview [customMap]="addedCustomMap" [isUpdateMode]="false" [selectedLayer]="selectedLayer"></mee-map-preview>
  </div>
</div>
